import React, { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import PhysicianRecommendationForm, { PhysicianRecommendationDataFormItem } from "../../../../forms/corpoClinico/PhysicianRecommendationDataForm";
import Controls from "../../../../components/controls/Controls";
import AcademicService from "../../../../services/AcademicService";
import { ITableHeaderProps } from "../../../../components/controls/Table";



interface IPhysicianRecommendationComponentProps {
    PhysicianRecommendationForm: PhysicianRecommendationForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: PhysicianRecommendationDataFormItem) => void
    onDeleteClick: (e: PhysicianRecommendationDataFormItem) => void
    onCancelItem: () => void
}

/* eslint-disable no-useless-escape */
export default function PhysicianRecommendationComponent(props: IPhysicianRecommendationComponentProps) {

    const headers: ITableHeaderProps[] = [
        { title: "Nome", align: "left", property: "Name", type: "text" },
        { title: "CRM", align: "center", property: "CRM", type: "text" },
        { title: "Email", align: "center", property: "Email", type: "text" },
        { title: "Especialidade", align: "center", property: "Specialty", type: "text" }
    ]

    const [specialtyStateOptions, setSpecialtyStateOptions] = useState([])

    useEffect(() => {
        AcademicService.getAllSpecialtyOptions().then(e => setSpecialtyStateOptions(e))
    }, []);

    return (
        <Grid container spacing={5}>

            <Grid item xs = {12} sm = {12}>
                <Typography variant="body1">
                    Indicar 5 nomes de médicos cadastrados, atuantes e elegíveis no Corpo Clínico do Hospital Sírio-Libanês.
                </Typography>
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="Name"
                    label="Nome"
                    maxLength={60}
                    placeholder="Digite o nome"
                    value={props.PhysicianRecommendationForm.Name.Value}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '');
                        props.onInputChange("Name", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Name", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    error={props.PhysicianRecommendationForm.Name.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="CRM"
                    label="CRM"
                    maxLength={20}
                    placeholder="Digite o CRM"
                    value={props.PhysicianRecommendationForm.CRM.Value}
                    onChange={(e) => {
                        e.target.value = e.target.value.replace(/[`~!@#$%^&*()_|+\=?;:'",¨<>\{\}\[\]\\\/]/gi, '');
                        props.onInputChange("CRM", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("CRM", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    error={props.PhysicianRecommendationForm.CRM.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Input
                    name="Email"
                    label="Email"
                    maxLength={255}
                    placeholder="Digite o e-mail"
                    value={props.PhysicianRecommendationForm.Email.Value}
                    onChange={(e) => {
                        props.onInputChange("Email", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Email", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    error={props.PhysicianRecommendationForm.Email.Error}
                />
            </Grid>

            <Grid item xs={6} sm={6}>
                <Controls.Autocomplete
                    label="Especialidade *"
                    name="Specialty"
                    placeholder="Selecione"
                    options={specialtyStateOptions}
                    value={props.PhysicianRecommendationForm.Specialty.Value}
                    onChange={(e) => {
                        props.onInputChange("Specialty", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    onBlur={(e) => {
                        props.onInputChange("Specialty", props.PhysicianRecommendationForm, e.target.value);
                    }}
                    error={props.PhysicianRecommendationForm.Specialty.Error}
                />
            </Grid>

            <Grid item xs={12}>
                <Box style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>

                    {(props.PhysicianRecommendationForm.PhysicianRecommendationDataFormItemToEdit.Id > 0 ?
                        <Controls.Button text="Cancelar" type="Error" onClick={props.onCancelItem} /> : null
                    )}

                    {(props.PhysicianRecommendationForm.PhysicianRecommendationDataFormItemToEdit.Id === 0 ?
                        <Controls.Button text="Adicionar" type="Success" onClick={props.onInserOrUpdateItem} />
                        : <Controls.Button text="Salvar" type="Success" onClick={props.onInserOrUpdateItem} />
                    )}

                </Box>
            </Grid>
            <Grid item xs={12} sm={12}>
                <Typography>
                    {props.PhysicianRecommendationForm.PhysicianRecommendationDataFormItemList.length} de 5 indicações
                </Typography>
            </Grid>               
            <Grid item xs={12}>
                <Controls.Table
                    headers={headers}
                    actionColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick} 
                    rows={props.PhysicianRecommendationForm.PhysicianRecommendationDataFormItemList}
                />
            </Grid>

        </Grid>
    );
}